import React from 'react';

const Spinner = () => (
  <div className="tw-absolute tw-h-full tw-w-full tw-text-3xl tw-flex tw-items-center tw-justify-center">
    <i className="fa fa-spinner fa-spin" aria-hidden="true" />
  </div>
);

export default Spinner;
